export default __webpack_public_path__ + "static/media/liveCoursesIcon.6ee943bb.svg";